import { Glyph } from '../common/Glyph';

import { useI18n } from '../../hooks/useI18nFormatters';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import styles from './IndicatorUnavailableStatus.module.css';

export function IndicatorUnavailableStatus() {
  const { i18n } = useI18n();

  return (
    <div className={styles.root}>
      <Glyph
        className={styles.statusIcon}
        source={glyph.core.exclamationmarkTriangleFill}
        color={theme.color.error}
        size={theme.icon.size_small}
      />
      <div className={styles.errorText}>{i18n.messageFormatter('common.unavailable')}</div>
    </div>
  );
}
